import React from 'react';
import { TabPane } from 'reactstrap';
import { TABS } from '../..';
import { AutoSizer, List } from 'react-virtualized';
import QueueTag from '../QueueTag';

export const TabAttributedChats = ({
  queues,
  idNameTags,
  answerConversation,
  chats,
  currentOpenChatId
}) => {
  return (
    <TabPane
      tabId={TABS.ATTRIBUTED}
      style={{
        width: '100%',
        height: '94%'
      }}
    >
      <AutoSizer>
        {({ width, height }) => (
          <List
            style={{
              scrollbarWidth: 'thin',
              margin: '0px',
              padding: '0px'
            }}
            width={width}
            height={height}
            rowHeight={140}
            rowCount={chats?.length || 0}
            rowGetter={({ index }) => chats[index] || {}}
            rowRenderer={({ key, index, style }) => {
              return (
                <div key={key} style={style}>
                  <QueueTag
                    key={key}
                    style={style}
                    conversation={chats[index]}
                    isSelected={chats[index]?._id === currentOpenChatId}
                    allQueues={queues}
                    idNameTags={idNameTags}
                    functionAnswerConversation={answerConversation}
                  />
                </div>
              );
            }}
          />
        )}
      </AutoSizer>
    </TabPane>
  );
};
